import axios, { isAxiosError } from 'axios';

export interface TaskManagementTopic {
  id: number;
  name: string;
}

export interface TaskManagementGroup {
  id: number;
  name: string;
}

function parseTopicsResponse(data: TaskManagementTopic[] | { topics: TaskManagementTopic[] }): TaskManagementTopic[] {
  return Array.isArray(data) ? data : (data?.topics ?? []);
}

/**
 * Lists Task Management groups for the Contact Form organization dropdown.
 */
export async function fetchPublicGroups(
  endpoint: string,
  parentOrganizationId: number | string,
): Promise<TaskManagementGroup[]> {
  const url = new URL('/api/v4/task_management/public/groups', endpoint).toString();

  const { data } = await axios.get<TaskManagementGroup[]>(url, {
    params: { parent_organization_id: parentOrganizationId },
  });

  return data ?? [];
}

/**
 * Lists Contact Form topics for a Task Management group (visibility-filtered on the BE).
 */
export async function fetchPublicGroupTopics(
  endpoint: string,
  groupId: number | string,
): Promise<TaskManagementTopic[]> {
  const url = new URL(`/api/v4/task_management/public/groups/${groupId}/topics`, endpoint).toString();

  const { data } = await axios.get<TaskManagementTopic[] | { topics: TaskManagementTopic[] }>(url);

  return parseTopicsResponse(data);
}

/**
 * Legacy: lists topics scoped to a secondary organization.
 */
export async function fetchPublicSecondaryOrgTopics(
  endpoint: string,
  secondaryOrgId: number | string,
): Promise<TaskManagementTopic[]> {
  const url = new URL(
    `/api/v4/task_management/public/secondary_organizations/${secondaryOrgId}/topics`,
    endpoint,
  ).toString();

  const { data } = await axios.get<TaskManagementTopic[] | { topics: TaskManagementTopic[] }>(url);

  return parseTopicsResponse(data);
}

export function isForbiddenError(error: unknown): boolean {
  return isAxiosError(error) && error.response?.status === 403;
}
